// Generated by barrles.ps1

export * from "./base-app-component.component";
export * from "./component-base.component";
